import o from"react-dom";var e,t=o;t.createRoot,e=t.hydrateRoot;const a=Object.freeze(Object.defineProperty({__proto__:null,get hydrateRoot(){return e}},Symbol.toStringTag,{value:"Module"}));export{a as c};
